import { useState, useEffect } from "react";
import { getApiData, getDataFromCache, getTableData } from './apiDataService';
import { getApiDataItems } from "./apiDataUtils";
import { usePageProps } from "./../../context/PagePropContext";;
import { CONTENT_VARIABLES } from './contentVariables';
import Status from './status';

/**
 * Custom hook that retrieves live Api Data based on Data Source values specified in page props
 */
export default function useApiData() {
    const pageProps = usePageProps();
    const apiDataPageProps = getApiDataItems(pageProps.apiData);
    const tableDataPageProps = getApiDataItems(pageProps.tableData);
    const [isApiDataRequesting, setApiDataRequesting] = useState(false);
    const [isTableDataRequesting, setTableDataRequesting] = useState(false);
    const { tableEntries }  = usePageProps();
    const apiData = apiDataPageProps.length !== 0 ? getDataFromCache(apiDataPageProps) : null;
    const tableData = tableDataPageProps.length !== 0 ? getDataFromCache(tableDataPageProps) || tableEntries : null;
    const [isApiDataLoaded, setApiDataLoaded] = useState(false);
    const [isTableDataLoaded, setTableDataLoaded] = useState(false);

    // if new api data is required and was not found in cache, request from API
    useEffect(() => {
        async function getData() {
            await getApiData(apiDataPageProps);
            setApiDataRequesting(false);
            setApiDataLoaded(true);
        }
        if (apiData === undefined && !isApiDataRequesting) {
            setApiDataRequesting(true);
            getData();
        }
        if (apiData !== undefined) {
            setApiDataLoaded(true);
        }
    }, [apiDataPageProps.join('')]);

    useEffect(() => {
        async function getData() {
            await getTableData(tableDataPageProps);
            setTableDataRequesting(false);
            setTableDataLoaded(true);
        }
        if (tableData === undefined && !isTableDataRequesting) {
            setTableDataRequesting(true);
            getData();
        }
        if (tableData !== undefined) {
            setTableDataLoaded(true);
        }
    }, [tableDataPageProps.join('')]);

    return {
        data: {
            ...apiData,
            ...tableData,
            ...CONTENT_VARIABLES 
        },
        status: isApiDataLoaded && isTableDataLoaded ? Status.LOADED : Status.LOADING,
    };
}